import { ChatSession } from '../../../domain/chat/models/ChatSession';
import { ChatProviderType } from '../../../domain/chat/models/ChatProviderType';
import { ProviderServices } from '../../../services/chat/createProviderServices';
import { DownloadChatSession } from '../../../services/providers/progpt/dtos/responses/ProGPTDownloadChatSessionDto';

interface DownloadChatSessionHandlerParams {
    session: ChatSession;
    accessToken: string;
    providerServices: ProviderServices;
}

export const downloadChatSessionHandler = async ({
    session,
    accessToken,
    providerServices,
}: DownloadChatSessionHandlerParams): Promise<DownloadChatSession> => {
    if (session.providerType === ChatProviderType.Assistants) {
        return providerServices.assistants.sessions.downloadChatSessionAsync(session.id, accessToken);
    }
    return providerServices.proGPT.sessions.downloadChatSessionAsync(session.id, accessToken);
};
